/**
 * ============================================================================
 * SECTION CARD — shared white rounded-card container with a title.
 * ============================================================================
 *
 * The standard wrapper for dashboard content blocks (tables, charts,
 * glossaries). Keeps card chrome consistent app-wide — change the card look
 * once here, not per feature.
 */

import React from 'react';
import './SectionCard.scss';

interface SectionCardProps {
  title: string;
  /** Optional right-aligned header content (toolbars, badges). */
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export const SectionCard: React.FC<SectionCardProps> = ({ title, actions, children }) => (
  <section className="section-card">
    <div className="section-card__header">
      <h2>{title}</h2>
      {actions && <div className="section-card__actions">{actions}</div>}
    </div>
    {children}
  </section>
);
